import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LayoutDashboard, Users, FilePlus, MapPinned, Settings, ShieldCheck } from 'lucide-react';

export function BottomNav() {
  const location = useLocation();
  const { isAdmin, canAccessTourenplanung } = useAuth();

  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard', show: true },
    { path: '/patienten', icon: Users, label: 'Patienten', show: true },
    { path: '/tourenplanung', icon: MapPinned, label: 'Touren', show: canAccessTourenplanung },
    { path: '/neuer-bericht', icon: FilePlus, label: 'Neu', show: true },
    { path: isAdmin ? '/admin' : '/einstellungen', icon: isAdmin ? ShieldCheck : Settings, label: isAdmin ? 'Admin' : 'Mehr', show: true },
  ].filter(i => i.show);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 md:hidden" data-testid="bottom-nav">
      <div className="flex items-center justify-around h-16 px-2 max-w-lg mx-auto">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
          return (
            <NavLink
              key={path}
              to={path}
              data-testid={`nav-${label.toLowerCase()}`}
              className={`flex flex-col items-center justify-center min-w-[60px] min-h-[44px] rounded-xl transition-all ${
                isActive
                  ? 'text-teal-700'
                  : 'text-slate-400 hover:text-slate-600'
              }`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : ''}`} />
              <span className="text-[10px] mt-1 font-medium">{label}</span>
            </NavLink>
          );
        })}
      </div>
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
